import { useContext, useState } from "react";
import { apiUrls } from "../../../utils/apiUrls";
import { AxiosAuth } from "../../../core/axios";
import { CellProps, Cell } from "rsuite-table";
import { Loader } from "rsuite";
import { NotificationContext } from "../../../core/context/notificationContextProvider";
import fileDownload from "js-file-download";
import { notificationContextTypes } from "../../../utils/typeDefs";
import { AxiosResponse } from "axios";

export const TitleCell = ({
  rowData,
  dataKey,
  url,
  ...props
}: CellProps<any> & { url: string }) => {
  const { triggerNotification } = useContext(
    NotificationContext
  ) as notificationContextTypes;

  const [showLoader, setShowLoader] = useState<boolean>(false);

  const getContent = async (url: string) => {
    try {
      const response: AxiosResponse<
        string | Blob | ArrayBufferView | ArrayBuffer
      > = await AxiosAuth.post(
        url,
        {
          id: rowData.id,
          countryId: rowData.countryId,
        },
        {
          responseType: "blob",
        }
      );

      if (response.status === 200) {
        fileDownload(response.data, `${rowData.title}.pdf`);
      }
    } catch (error) {
      triggerNotification(false, "Failed to download content");
    }
  };

  return (
    <Cell {...props}>
      <span
        onClick={() => {
          setShowLoader(true);
          getContent(
            url === "Form"
              ? apiUrls.form.getFormContent
              : apiUrls.regulation.getRegulationContent
          ).then(() => setShowLoader(false));
        }}
      >
        {showLoader && <Loader size="sm" />} {rowData.title}
      </span>
    </Cell>
  );
};
